import { t } from "../lib/i18n";
import LanguageSwitcher from "./LanguageSwitcher";
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Import useLocation


import logo from '../assets/logo.png';

const StarIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
 <path d="M3 21H21M6 18V9.99998M10 18V9.99998M14 18V9.99998M18 18V9.99998M20 6.99998L12.424 2.26498C12.2702 2.16884 12.1933 2.12077 12.1108 2.10203C12.0379 2.08546 11.9621 2.08546 11.8892 2.10203C12.0379 2.12077 11.7298 2.16884 11.576 2.26498L4 6.99998H20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

const PaperIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
 <path d="M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.6499 21H18.6599" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

const KnowledgeHubIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
 <path d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

const GraphIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
 <path d="M7 20V4M7 4L3 8M7 4L11 8M17 20V9M17 9L13 13M17 9L21 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

const AccountIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
   <path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
   </svg>
);

const SignOutIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-4 h-4">
 <path d="M18 8L22 12M22 12L18 16M22 12H9M15 4.20404C13.7252 3.43827 12.2452 3 10.6667 3C5.8802 3 2 7.02944 2 12C2 16.9706 5.8802 21 10.6667 21C12.2452 21 13.7252 20.5617 15 19.796" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
);

interface NavbarProps {
  handleSignOut: () => Promise<void>;
}

const Navbar: React.FC<NavbarProps> = ({ handleSignOut }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [coreDropdownOpen, setCoreDropdownOpen] = React.useState(false);
  const [documentsDropdownOpen, setDocumentsDropdownOpen] = React.useState(false);
  const [growthDropdownOpen, setGrowthDropdownOpen] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const coreDropdownRef = React.useRef<HTMLDivElement>(null);
  const documentsDropdownRef = React.useRef<HTMLDivElement>(null);
  const growthDropdownRef = React.useRef<HTMLDivElement>(null);

  const onSignOutClick = async () => {
    await handleSignOut();
    navigate('/');
  };

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (coreDropdownRef.current && !coreDropdownRef.current.contains(event.target as Node)) {
        setCoreDropdownOpen(false);
      }
      if (documentsDropdownRef.current && !documentsDropdownRef.current.contains(event.target as Node)) {
        setDocumentsDropdownOpen(false);
      }
      if (growthDropdownRef.current && !growthDropdownRef.current.contains(event.target as Node)) {
        setGrowthDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  React.useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav className="bg-bg-primary text-text-primary p-4 flex justify-between items-center w-full relative">
      <div className="flex items-center">
        <Link to="/dashboard" className="flex items-center no-underline">
          <img 
            src={logo} 
            alt={t("navbar.k1")} 
            className="h-20 sm:h-24 md:h-28 w-auto object-contain mr-4 hover:opacity-95 transition-opacity"
          />
        </Link>
      </div>
      
      <div className="md:hidden">
        <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-text-primary focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>
      
      <div className="hidden md:flex items-center gap-4">
          <div className="relative" ref={coreDropdownRef}>
            <button type="button" onClick={() => setCoreDropdownOpen(!coreDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none">
              <StarIcon />
              <span>{t("navbar.k2")}</span>
            </button>
            <div className={`${coreDropdownOpen ? 'block' : 'hidden'} absolute bg-transparent min-w-[160px] z-10 list-none p-0 m-0`}>
              <Link to="/dashboard" onClick={() => setCoreDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k3")}</Link>
              <Link to="/properties" onClick={() => setCoreDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k4")}</Link>
              <Link to="/tenants" onClick={() => setCoreDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k5")}</Link>
              <Link to="/leases" onClick={() => setCoreDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k6")}</Link>
            </div>
          </div>

          <div className="relative" ref={documentsDropdownRef}>
            <button type="button" onClick={() => setDocumentsDropdownOpen(!documentsDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none">
              <PaperIcon />
              <span>{t("navbar.k7")}</span>
            </button>
            <div className={`${documentsDropdownOpen ? 'block' : 'hidden'} absolute bg-transparent min-w-[160px] z-10 list-none p-0 m-0`}>
              <Link to="/documents" onClick={() => setDocumentsDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k7")}</Link>
              <Link to="/lease-abstraction" onClick={() => setDocumentsDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k8")}</Link>
              <Link to="/bulk-leases" onClick={() => setDocumentsDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k9")}</Link>
            </div>
          </div>

          <div className="relative" ref={growthDropdownRef}>
            <button type="button" onClick={() => setGrowthDropdownOpen(!growthDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none">
              <GraphIcon />
              <span>{t("navbar.k10")}</span>
            </button>
            <div className={`${growthDropdownOpen ? 'block' : 'hidden'} absolute bg-transparent min-w-[160px] z-10 list-none p-0 m-0`}>
              <Link to="/deal-sourcing" onClick={() => setGrowthDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k11")}</Link>
              <Link to="/underwriting" onClick={() => setGrowthDropdownOpen(false)} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline">{t("navbar.k12")}</Link>
            </div>
          </div>

          <Link to="/account" className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none">
            <AccountIcon />
            <span>{t("navbar.k13")}</span>
          </Link>
          <LanguageSwitcher compact />
          <button onClick={onSignOutClick} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none">
            <SignOutIcon />
            <span>{t("navbar.k14")}</span>
          </button>
        </div>
      
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-bg-primary shadow-lg py-2 z-50 max-h-[calc(100vh-4rem)] overflow-y-auto">
          <div className="flex justify-end p-4">
            <button onClick={() => setIsMobileMenuOpen(false)} className="text-text-primary focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <div className="flex flex-col items-start px-4">
            <div className="relative w-full py-2" ref={coreDropdownRef}>
              <button type="button" onClick={() => setCoreDropdownOpen(!coreDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none w-full justify-start">
                <StarIcon />
                <span>{t("navbar.k2")}</span>
              </button>
              <div className={`${coreDropdownOpen ? 'block' : 'hidden'} bg-transparent min-w-[160px] z-10 list-none p-0 m-0 mt-2`}>
                <Link to="/dashboard" onClick={() => { setCoreDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k3")}</Link>
                <Link to="/properties" onClick={() => { setCoreDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k4")}</Link>
                <Link to="/tenants" onClick={() => { setCoreDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k5")}</Link>
                <Link to="/leases" onClick={() => { setCoreDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k6")}</Link>
              </div>
            </div>

            <div className="relative w-full py-2" ref={documentsDropdownRef}>
              <button type="button" onClick={() => setDocumentsDropdownOpen(!documentsDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none w-full justify-start">
                <PaperIcon />
                <span>{t("navbar.k7")}</span>
              </button>
              <div className={`${documentsDropdownOpen ? 'block' : 'hidden'} bg-transparent min-w-[160px] z-10 list-none p-0 m-0 mt-2`}>
                <Link to="/documents" onClick={() => { setDocumentsDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k7")}</Link>
                <Link to="/lease-abstraction" onClick={() => { setDocumentsDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k8")}</Link>
                <Link to="/bulk-leases" onClick={() => { setDocumentsDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k9")}</Link>
              </div>
            </div>

            <div className="relative w-full py-2" ref={growthDropdownRef}>
              <button type="button" onClick={() => setGrowthDropdownOpen(!growthDropdownOpen)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none w-full justify-start">
                <GraphIcon />
                <span>{t("navbar.k10")}</span>
              </button>
              <div className={`${growthDropdownOpen ? 'block' : 'hidden'} bg-transparent min-w-[160px] z-10 list-none p-0 m-0 mt-2`}>
                <Link to="/deal-sourcing" onClick={() => { setGrowthDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k11")}</Link>
                <Link to="/underwriting" onClick={() => { setGrowthDropdownOpen(false); setIsMobileMenuOpen(false); }} className="text-text-primary hover:bg-gray-200 hover:text-gray-800 block text-left no-underline px-4 py-2">{t("navbar.k12")}</Link>
              </div>
            </div>

            <Link to="/account" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none w-full py-2 justify-start">
              <AccountIcon />
              <span>{t("navbar.k13")}</span>
            </Link>
            <button onClick={onSignOutClick} className="flex items-center gap-2 text-text-primary hover:text-gray-500 focus:outline-none !bg-transparent !border-none w-full py-2 justify-start">
              <SignOutIcon />
              <span>{t("navbar.k14")}</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
